module.exports = __webpack_public_path__ + "static/img/3.d77a5489.png";